export default __webpack_public_path__ + "static/media/icon_done_success_check.38a8b013.svg";